module.exports = __webpack_public_path__ + "static/media/icon_new.a610b281.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_new.svg
// module id = 2022
// module chunks = 0